import Families from 'pages/CatalogPage/IAM/MaintenancePlan/Families/Families';

export default Families;
